var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"w-100",attrs:{"autoplay":"","loop":"","playsinline":"","crossorigin":"","id":"workout-video-loop"}})
}
var staticRenderFns = []

export { render, staticRenderFns }